export default function () {
  let blanks = []
  let blanksBySentence = []
  let sentences = [
    "One wonderful day I left [place] to attend WDS.",
    "I arrived to Portland full of [emotion] and made the journey in search of [pursuit] .",
    //1
    "When I arrived at registration, there was quite a clamor! No one could believe their eyes when they saw the team handing out [swag item] !",
    "The Ambassadors were as friendly as ever, and this year they were all wearing matching [item of clothing] .",
    "It wasn't long before I made my first new friend, [name].  I was amazed to discover they are a professional [profession] !",
    // 4
    "After hours of chatting, dancing and [activity] at the opening party, it was time for bed. Big day tomorrow!",
    "The next morning, it felt great to be back at the main stage, the [prop item] on stage really impressed!",
    "The lights dimmed and suddenly there was a loud boom! Imagine our faces when Chris entered by [stage entrance] .",
    "I have to say, all the speakers were great but [speaker name] 's talk on [topic] really had an impact on me.",
    // 8
    "Sunday was even better! But, I couldn't stop thinking about the closing party... Would this be the year we would finally be able to [activity]?",
    "Yes! I don't know how they did it! Even better, DJ Prashant was there to teach us his all new dance called [dance name]!",
    // 10
    "When I awoke the next morning, I felt ready to take on the world and overwhelmed with inspiration to finally [action].",
  ].map((str) => {
    const bs = []
    let sentence = ""
    let blank = ""
    let inBlank = false
    str.split("").forEach((c) => {
      if (c === "[") {
        inBlank = true
      } else if (c === "]" && inBlank) {
        inBlank = false
        sentence += `%blank-${blanks.length}`
        bs.push(blank)
        blanks.push(blank)
        blank = ""
      } else if (inBlank) {
        blank += c
      } else {
        sentence += c
      }
    })
    blanksBySentence.push(bs)
    return sentence
  })
  return {
    participants: {},
    sentences,
    onStatus: "waiting",
    onSentence: 0,
    allowSubmit: false,
    onPhase: 0,
    maxPerRound: 25,
    nextPhase: -1,
    blanks,
    blanksBySentence: JSON.stringify(blanksBySentence),
    submitTime: 40,
    voteTime: 30,
    reviewTime: 25,
    submissions: [],
    votes: [],
  }
}
